import dayjs from 'dayjs';
import type { Ref } from 'vue';
import { computed } from 'vue';

import { useReleaseNotes } from '@/apis/queries/useReleaseNotes';
import { useLocalStorage } from '@/composables/useLocalStorage';

const STORAGE_KEY = 'release-panel-last-seen';

export function useReleasePanelNotification() {
  const { notes, isLoading } = useReleaseNotes();
  const lastSeen = useLocalStorage(STORAGE_KEY, null) as Ref<string | null>;

  const newestNoteDate = computed(() => {
    if (!notes.value?.length) return null;
    return notes.value[0].sys.createdAt;
  });

  const hasNewReleaseNotes = computed(() => {
    if (isLoading.value || !newestNoteDate.value) return false;
    if (!lastSeen.value) return true;
    return dayjs(newestNoteDate.value).isAfter(dayjs(lastSeen.value));
  });

  function markAsSeen() {
    if (newestNoteDate.value) {
      lastSeen.value = newestNoteDate.value;
    }
  }

  return { hasNewReleaseNotes, markAsSeen };
}
